import { BaseZenputCollection, BaseZenputModel } from '../../../../backbone-unorganized/shared/forms';
import { MobileBaseField } from '../BaseField/models';

export const MobileYesNoField = MobileBaseField.extend({
    yesno_history_items_by_account: null, // { <account id>: <YesNoHistoryItemList> }

    initialize: function (attrs, options) {
        MobileYesNoField.__super__.initialize.apply(this, arguments);

        // define this in initialize to avoid pass-by-reference issues caused by defining it statically as class var
        this.yesno_history_items_by_account = this.yesno_history_items_by_account || {};
    },

    get_history: function (callback) {
        var this_ = this;

        if (!this.collection) {
            return callback(null);
        }

        var account_field = this.collection.findWhere({ type: 'account' });

        if (!account_field) {
            return callback(null); // don't want to get submission history if no account is selected
        }

        this.collection.get_previous_submissions({
            account_field: account_field,
            success: function (submissions) {
                if (!submissions || !submissions.length) {
                    return callback(null);
                }

                // Build a YesNoHistoryItemList for our field history
                var history_items = new YesNoHistoryItemList();

                submissions.each(function (sub) {
                    var previous_form_structure = sub.get('form_structure');
                    var old_field = previous_form_structure.get(this_.id);

                    if (!old_field) {
                        return true;
                    }

                    history_items.add({
                        id: sub.id,
                        date_submitted: previous_form_structure.smetadata.get('date_submitted'),
                        value: old_field.get('value'),
                        acceptance_value: old_field.get('acceptance_value')
                    });
                });

                callback(history_items);
            },
            error: function () {
                callback(null);
            }
        });
    }
});

export const YesNoHistoryItem = BaseZenputModel.extend({
    defaults: {
        id: null,
        date_submitted: null,
        acceptance_value: null,
        value: null // keeping the old style values because we are not back-propogating the acceptance criteria after it is set
    }
});

export const YesNoHistoryItemList = BaseZenputCollection.extend({
    model: YesNoHistoryItem,

    /**
     * Always order from oldest to newest.
     */
    comparator: function (model) {
        return model.get('date_submitted').$date;
    }
});
